import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../notification/notification.service';
import {
  CourierPickup,
  CourierPickupDay,
  CourierPickupsService,
} from '../api';

type DayLabel = 'Mára' | 'Holnapra';

/**
 * Futár rendelés — Stokker design (11-futar-rendeles.html),
 * viselkedés a 23-logic.js courierVals-ből 1:1.
 * A pickup igénylést a CourierPickupsService küldi (POST courier-pickups),
 * a korábbi igénylések listáját a GET adja (404 → üres állapot).
 */
@Component({
  selector: 'app-futar-rendeles',
  templateUrl: './futar-rendeles.component.html',
  styleUrl: './futar-rendeles.component.scss'
})
export class FutarRendelesComponent implements OnInit {

  readonly dayChips: DayLabel[] = ['Mára', 'Holnapra'];
  readonly boxChips = [1, 2, 3, 4, 5];

  day: DayLabel = 'Mára';
  boxes = 1;
  sent = false;
  sending = false;
  copied = false;

  pickups: CourierPickup[] = [];
  pickupsLoaded = false;

  constructor(
    private courierPickups: CourierPickupsService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.fetchPickups();
  }

  /** 23-logic.js: emailBody */
  get emailBody(): string {
    const dayLabel = this.day === 'Mára' ? 'mára' : 'holnapra';
    return 'Sziasztok!\n\nBGFox Kft. vagyunk, ' + dayLabel
      + ' szeretnénk FedEx futárt kérni ' + this.boxes
      + ' db csomag felvételéhez.\n\nKöszönjük!\nBGFox Kft.';
  }

  /** 23-logic.js: courierSentMsg — a szöveg a tényleges viselkedést tükrözi:
   *  az igény rögzül a rendszerben, az emailt jelenleg kézzel kell elküldeni
   *  (a Spring GDS felé automatikus küldés még nincs bekötve). */
  get sentMsg(): string {
    return (this.day === 'Mára' ? 'Mai' : 'Holnapi') + ' napra, ' + this.boxes
      + ' doboz — az igény rögzítve. Az alábbi emailt küldd el a Spring GDS-nek;'
      + ' a címkét emailben küldik vissza.';
  }

  pickDay(day: DayLabel) {
    this.day = day;
    this.sent = false;
  }

  pickBoxes(boxes: number) {
    this.boxes = boxes;
    this.sent = false;
  }

  /** A siker-kártyán látható email vágólapra másolása (a szöveget kézzel kell elküldeni). */
  copyEmail() {
    const done = () => {
      this.copied = true;
      setTimeout(() => (this.copied = false), 2000);
    };
    const body = this.emailBody;
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(body).then(done, () => {
        this.notificationService.show('Nem sikerült a vágólapra másolni — jelöld ki kézzel.', 'warning');
      });
      return;
    }
    this.notificationService.show('Nem sikerült a vágólapra másolni — jelöld ki kézzel.', 'warning');
  }

  send() {
    if (this.sending) {
      return;
    }
    this.sending = true;
    const day: CourierPickupDay = this.day === 'Mára' ? 'today' : 'tomorrow';
    this.courierPickups.createPickup({ day, boxes: this.boxes }).subscribe((pickup) => {
      this.sending = false;
      this.sent = true;
      if (pickup) {
        this.pickups = [pickup, ...this.pickups];
        this.pickupsLoaded = true;
      }
    }, e => {
      this.sending = false;
      this.notificationService.show(`Hiba a futár rendelés küldése során! Részletek: ${e.message}`, 'danger');
    });
  }

  /** 23-logic.js: courierReset */
  reset() {
    this.sent = false;
    this.boxes = 1;
    this.day = 'Mára';
  }

  dayLabelOf(pickup: CourierPickup): string {
    return pickup.day === 'today' ? 'Mai napra' : 'Holnapi napra';
  }

  trackById(_: number, pickup: CourierPickup) {
    return pickup.id;
  }

  private fetchPickups() {
    this.courierPickups.getPickups().subscribe((pickups) => {
      this.pickups = pickups || [];
      this.pickupsLoaded = true;
    }, () => {
      // A backend még nem él (pl. 404) — üres listaként kezeljük, hiba nélkül.
      this.pickups = [];
      this.pickupsLoaded = true;
    });
  }
}
